export const truncateStringByWord = (
  str: string = '',
  length: number = 0,
  suffix: string = '...',
) => {
  let result = str;

  if (result.length > length) {
    result = result.substr(0, length);
    result = result.substr(0, Math.min(result.length, result.lastIndexOf(' ')));
    result += suffix;
  }

  return result;
};
